import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Peeling } from "./peeling.entity";
@Entity('peeling_samples')
export class PeelingSamples {
    @PrimaryGeneratedColumn('increment', {
        name: 'peeling_samples_id',
    })
    peelingSamplesId: number;

    @Column('int', {
        name: 'peeling_id'
    })
    peelingId: number


    @Column({
        type: 'int',
        nullable: false,
        name: 'sample_no'
    })
    sampleNo: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'temperature'
    })
    temperature: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'count'
    })
    count: number;

    @Column('varchar', {
        nullable: false,
        name: 'type_of_cut',
    })
    typeOfCut: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'big_small_ratio'
    })
    bigToSmallRatio: number;

    @Column('varchar', {
        nullable: false,
        name: 'legs_veins_shell',
    })
    legsVeinsShell: string;

    @Column("varchar", {
        nullable: false,
        name: "improper_cutting"
    })
    improperCutting: string;

    @Column('varchar', {
        nullable: false,
        name: 'blacktail_blackspot',
    })
    blackTailBlackSpot: string;

    @Column("varchar", {
        nullable: false,
        name: "broken_unstable"
    })
    brokenUnstable: string;

    @Column("varchar", {
        nullable: false,
        name: "deterioration_decomposition"
    })
    deteriorationDecomposition: string;

    @Column("varchar", {
        nullable: false,
        name: "other_objectionable_defects"
    })
    otherObjectionableDefects: string;

    @Column('varchar', {
        nullable: false,
        name: 'remarks',
    })
    remarks: string;


    @Column('varchar', {
        nullable: false,
        name: 'checked_by',
    })
    checkedBy: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })

    versionFlag: number;

    @ManyToOne(type => Peeling, peeling => peeling.peelingSamplesInfo, { nullable: false })
    @JoinColumn({ name: 'peeling_id' })
    peelingInfo: Peeling;
}